export const UPLOAD_FILE_TEXT = {
    id: 'oe.report.uploadFile',
    defaultMessage: 'Upload File',
    description: 'Label text'
};
export const NEW_FILE_ADDED_TEXT = {
    id: 'oe.reports.fileAdded',
    description: 'Notification about added report',
    defaultMessage: 'New file added',
};
export const EDIT_FILE_TEXT = {
    id: 'oe.report.editFile',
    defaultMessage: 'Edit File',
    description: 'Label text'
};
export const FILE_EDITED_TEXT = {
    id: 'oe.reports.fileEdited',
    description: 'Notification about edit report',
    defaultMessage: 'File edited',
};
export const FILE_DELETED_TEXT = {
    id: 'oe.reports.fileDeleted',
    description: 'Notification about delete report',
    defaultMessage: 'File deleted',
};
export const REPORT_GENERATION_COMPLETED_TEXT = {
    description: 'Notification about changing report status',
    defaultMessage: 'Report generation has completed.',
    id: 'oe.reports.reportIsReady'
};
export const REPORT_GENERATION_STARTED_TEXT = {
    id: 'oe.reports.reportStarted',
    description: 'Notification about changing report status',
    defaultMessage: 'Report generation has started',
};
export const ONE_ROW_PER_ATTENDEE_TEXT = {
    id: 'oe.reports.oneRowPerAttendee',
    description: 'Label text',
    defaultMessage: '1 Row per Attendee (default)'
};
export const ONE_ROW_PER_ATTENDEE_PER_MEETING_TEXT = {
    id: 'oe.reports.oneRowPerAttendeePerMeeting',
    description: 'Label text',
    defaultMessage: '1 Row per Attendee per Meeting'
};